import { type AuditLightingCountFormEntry } from '#packages/data-collection/models/audit-lighting-count-form';

import { type EditAuditFormLightingCountEntryData } from './types';

export const fromFormData = (
  formData: EditAuditFormLightingCountEntryData,
): AuditLightingCountFormEntry => ({
  section: formData.section,
  room: formData.room,
  fixtureType: formData.fixtureType,
  fixtureQuantity: formData.fixtureQuantity,
  ceilingHeight: formData.ceilingHeight,
  surfaceType: formData.surfaceType,
  controls: formData.controls,
  operationHoursPerDay: formData.operationHoursPerDay,
  operationDaysPerWeek: formData.operationDaysPerWeek,
  comments: formData.comments,
});

export const toFormData = (
  entryData: AuditLightingCountFormEntry | undefined,
): Partial<EditAuditFormLightingCountEntryData> => ({
  section: entryData?.section,
  room: entryData?.room,
  fixtureType: entryData?.fixtureType,
  fixtureQuantity: entryData?.fixtureQuantity,
  ceilingHeight: entryData?.ceilingHeight,
  surfaceType: entryData?.surfaceType,
  controls: entryData?.controls,
  operationHoursPerDay: entryData?.operationHoursPerDay,
  operationDaysPerWeek: entryData?.operationDaysPerWeek,
  comments: entryData?.comments,
});
